import * as React from 'react';
import { Checkbox, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import FormValidationService from '../../../shared/form/FormValidationService';

export type BrokerFirmOtherInfoLabels = {
    fieldsetLegend: string;
    internalInfo: string;
    photographerInfo: string;
    deliveryWarning: string;
    imageEditingInfo: string;
    imageEditorFirm: string;
    editStyle: string;
    allowSE360ToBook: string;
    disallowCustomerToBook: string;
};

type BrokerFirmOtherInfoProps = {
    labels: BrokerFirmOtherInfoLabels;
    onAnyChange: (event: any) => void;
    availableImageEditorFirms: any[];
    internalInformation: string;
    photographerInformation: string;
    deliveryWarning: string;
    imageEditingInformation: string;
    imageEditorFirmId: string;
    editStyleIdError?: unknown;
    editStyleId: string;
    availableEditStyles: any[];
    allowSE360ToBook: boolean;
    disallowCustomerToBook: boolean;
};

export function BrokerFirmOtherInfo({
    labels,
    onAnyChange,
    availableImageEditorFirms = [],
    internalInformation,
    photographerInformation,
    deliveryWarning,
    imageEditingInformation,
    imageEditorFirmId,
    editStyleIdError,
    editStyleId,
    availableEditStyles = [],
    allowSE360ToBook,
    disallowCustomerToBook
}: BrokerFirmOtherInfoProps) {
    return (
        <fieldset>
            <legend aria-label={labels.fieldsetLegend}>{labels.fieldsetLegend}</legend>
            <FormGroup>
                <ControlLabel>{labels.internalInfo}</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    name="internalInformation"
                    value={internalInformation}
                    onChange={onAnyChange}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{labels.photographerInfo}</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    name="photographerInformation"
                    value={photographerInformation}
                    onChange={onAnyChange}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{labels.deliveryWarning}</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    name="deliveryWarning"
                    value={deliveryWarning}
                    onChange={onAnyChange}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{labels.imageEditingInfo}</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    name="imageEditingInformation"
                    value={imageEditingInformation}
                    onChange={onAnyChange}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{labels.imageEditorFirm}</ControlLabel>
                <FormSelect
                    name="imageEditorFirmId"
                    value={imageEditorFirmId}
                    onChange={onAnyChange}
                    defaultTranslateKey="broker-firm/form/image-editor-firm-default-option"
                >
                    {availableImageEditorFirms.map((x: any) => {
                        return (
                            <option value={x.id} key={x.id}>
                                {x.name}
                            </option>
                        );
                    })}
                </FormSelect>
            </FormGroup>
            <FormGroup validationState={FormValidationService.getValidationState(editStyleIdError)}>
                <ControlLabel>{labels.editStyle}</ControlLabel>
                <FormSelect
                    name="editStyleId"
                    value={editStyleId}
                    onChange={onAnyChange}
                    defaultTranslateKey="broker-firm/form/edit-style-default-option"
                >
                    {availableEditStyles.map((x: any) => {
                        return (
                            <option value={x.id} key={x.id}>
                                {x.name}
                            </option>
                        );
                    })}
                </FormSelect>
            </FormGroup>
            <Checkbox
                name="allowedToLetSE360Book"
                checked={allowSE360ToBook}
                onChange={onAnyChange}
            >
                <span>{labels.allowSE360ToBook}</span>
            </Checkbox>
            <Checkbox
                name="disallowCustomerToBook"
                checked={disallowCustomerToBook}
                onChange={onAnyChange}
            >
                <span>{labels.disallowCustomerToBook}</span>
            </Checkbox>
        </fieldset>
    );
}
